import http, {toBearerAuth} from '../../../../../util/httpClient';

type ReqBody = {
    name: any,
    link: string,
    description: any,
    isActive: boolean,
    darkLogo: string,
    logo: string
}

export const fetchListOfCampaigns = async (token: string) => {
    const res = await http.get<Record<any, any>[]>('/getCampaigns', {
        headers: {
            Authorization: toBearerAuth(token),
        },
    });
    return res.data;
};


export const fetcArchivedCampaigns = async(token: string) => {
    const res = await http.get<Record<any, any>[]>('/getArchivedCampaigns', {
        headers: {
            Authorization: toBearerAuth(token),
        }
    });
    return res.data;
};

export const createCampaign = async (token: string, campaignRequestBody: Partial<ReqBody>) => {
    const res = await http.post(
        '/createCampaigns',
        campaignRequestBody,
        { headers: { Authorization: toBearerAuth(token),'x-trace-id': "" } }
      );
      return res.data;
};

export const updateCampaign = async (token: string, campaignRequestBody: Partial<ReqBody>, campaignId : any) => {
    const res = await http.patch(
       `/updateCampaigns/${campaignId}`,
        campaignRequestBody,
        { headers: { Authorization: toBearerAuth(token),'x-trace-id': "" } }
      );
      return res.data;
};

export const archiveCampaign = async (token: string, campaignId: any) => {
    const res = await http.patch(
        `/archiveCampaign/${campaignId}`,
        {},
        {headers: {Authorization: toBearerAuth(token), 'x-trace-id': ""} }
    );

    return res.data;
}

export const runCampaignTranslator = async (token: string, requestBody: any) => {
    const res = await http.post('/translate',
        requestBody,
        { headers: { Authorization: toBearerAuth(token), 'x-trace-id': "" } }
    );

    return res.data;
}